import { Component } from '@angular/core';
import { HeaderComponent } from '../../header/header.component';
import { FooterComponent } from '../footer.component';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { RatingComponent } from '../../rating/rating.component';
import { SideNavComponent } from "../../side-nav/side-nav.component";

@Component({
  selector: 'app-accessibility',
  imports: [ RatingComponent, FooterComponent, CommonModule, MatIconModule, SideNavComponent],
  templateUrl: './accessibility.component.html',
  styleUrl: './accessibility.component.scss'
})
export class AccessibilityComponent {

}
